const FALLBACK_ICON = '/favicon.svg';

function getOrCreateIconLink(rel) {
  let link = document.querySelector(`link[rel="${rel}"]`);

  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }

  return link;
}

function updateIconLinks(url, type = 'image/png') {
  const icon = getOrCreateIconLink('icon');
  const shortcut = getOrCreateIconLink('shortcut icon');
  const apple = getOrCreateIconLink('apple-touch-icon');

  icon.type = type;
  icon.href = url;
  shortcut.href = url;
  apple.href = url;
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.referrerPolicy = 'no-referrer';
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });
}

function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Unable to generate profile favicon'));
    }, 'image/png');
  });
}

function drawCircularProfile(image) {
  const size = 192;
  const ring = 8;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  canvas.width = size;
  canvas.height = size;

  const gradient = context.createLinearGradient(0, 0, size, size);
  gradient.addColorStop(0, '#64e8ce');
  gradient.addColorStop(0.5, '#f5f7fa');
  gradient.addColorStop(1, '#a78bfa');

  context.beginPath();
  context.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  context.fillStyle = gradient;
  context.fill();

  context.save();
  context.beginPath();
  context.arc(
    size / 2,
    size / 2,
    size / 2 - ring,
    0,
    Math.PI * 2
  );
  context.clip();

  const target = size - ring * 2;
  const scale = Math.max(target / image.width, target / image.height);
  const width = image.width * scale;
  const height = image.height * scale;
  const x = (size - width) / 2;
  const y = (size - height) / 2;

  context.drawImage(image, x, y, width, height);
  context.restore();

  return canvas;
}

export async function installProfileFavicon(imageUrl) {
  if (typeof document === 'undefined') return undefined;

  try {
    const image = await loadImage(imageUrl);
    const canvas = drawCircularProfile(image);
    const blob = await canvasToBlob(canvas);
    const objectUrl = URL.createObjectURL(blob);

    updateIconLinks(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  } catch {
    updateIconLinks(FALLBACK_ICON, 'image/svg+xml');
    return undefined;
  }
}